import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { EmitType } from '@syncfusion/ej2-base';
import { ICustomerApplicationVariant } from '../../shared/models';
import { ICustomer } from '../../shared/models/customer.model';
import { StorageManagerService } from '../../shared/services/index';

@Component({
  selector: 'app-company-datascope-selector',
  templateUrl: './company-datascope-selector.component.html',
  styleUrls: ['./company-datascope-selector.component.scss']
})
export class CompanyDatascopeSelectorComponent implements OnInit, OnChanges {

  selectedCustomer: string;
  selectedapplicationVariant: string;
  header = 'Select';
  width = '25%';
  modalHeight = 'auto';
  position: object = { X: 'center', Y: 'center' };
  animationSettings: Object = { effect: 'None' };
  hide: any;
  fields: Object = { text: 'customerName', value: 'customerId' };
  subscriptionFields: Object = { text: 'applicationVariantName', value: 'applicationVariantId' };
  customersWaterMark = 'Select one';
  subscriptionsWaterMark = 'Select one';
  ddwHeight = '220px';
  ddwWidth = '384px';

  userGuid: string;


  @Input() customers: ICustomer[];
  @Input() subscriptions: ICustomerApplicationVariant[];
  @Input() companyDialogVisible: boolean;
  @Input() showDataScopeSelection: boolean;
  @Input() navigateToInput: string;

  @Output() currentCustomer = new EventEmitter<string>();
  @Output() companySelectionModalOutput = new EventEmitter<boolean>();

  @ViewChild('ddwCustomers', { static: true })
  ddwCustomers: DropDownListComponent;

  @ViewChild('ddwDataScopes', { static: true })
  ddwDataScopes: DropDownListComponent;

  @ViewChild('dialog', { static: true })
  dialog: DialogComponent;
  applicationVariantName: any;
  applyButtonEnabled = false;

  constructor (private storageManagerService: StorageManagerService, private router: Router) {

  }

  ngOnInit() {

    if (location.pathname !== '/home' && location.pathname !== '/' && location.pathname.indexOf('/fileupload') < 0 && location.pathname.indexOf('/exportdata') < 0) {

      this.showDataScopeSelection = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {

    // tslint:disable-next-line: forin
    for (const property in changes) {

      switch (property) {
        case 'customers':

          if (this.customers && !this.customers.length) {
            this.customers = this.storageManagerService.read('eligibleCustomers');
          }

          break;
        case 'companyDialogVisible':

          if (changes[property].currentValue) {
            this.dialog.show();
          }
          break;
      }
    }
  }


  companyDlgBtnClickApply: EmitType<object> = () => {

    if (this.applyButtonEnabled) {
      if (this.selectedapplicationVariant) {
        this.storageManagerService.write('dataScope', this.applicationVariantName.toLowerCase());
        this.storageManagerService.remove('userPrefs');
      }

      if (this.showDataScopeSelection) {

        if (this.storageManagerService.read('dataScope')) {

          this.dialog.hide();
          this.companySelectionModalOutput.emit(false);

          if (!this.selectedCustomer) {
            this.selectedCustomer = this.ddwCustomers.value.toString();
          }

          this.processCustomer(+this.selectedCustomer);

          if (location.pathname.indexOf('/error') >= 0) {
            this.router.navigate(['/']);
          } else {
            if (this.navigateToInput) {
              this.router.navigate([this.navigateToInput]);
            }
          }
        }
      } else {

        this.dialog.hide();
        this.companySelectionModalOutput.emit(false);

        if (!this.selectedCustomer) {
          this.selectedCustomer = this.ddwCustomers.value.toString();
        }

        // Remove the datascope of the changed Client
        this.storageManagerService.remove('dataScope');
        this.applicationVariantName = '';

        this.processCustomer(+this.selectedCustomer);

        if (location.pathname.indexOf('/error') >= 0) {
          this.router.navigate(['/']);
        } else {
          if (this.navigateToInput) {
            this.router.navigate([this.navigateToInput]);
          }
        }
      }
    }


  }

  companyDlgBtnClickCancel: EmitType<object> = () => {

    this.dialog.hide();
    this.companySelectionModalOutput.emit(false);
  }


  // tslint:disable-next-line: member-ordering
  dlgButtons: Object[] = [{ click: this.companyDlgBtnClickCancel.bind(this), buttonModel: { content: 'Cancel' } }, { click: this.companyDlgBtnClickApply.bind(this), buttonModel: { content: 'Apply', isPrimary: true, cssClass: 'e-disabled' } }];


  processCustomer(customerToFind: number) {

    let customer;

    if (this.customers && this.customers.length > 0) {

      customer = this.customers.find(c => c.customerId === customerToFind);

      if (customer) {
        this.dialog.hide();
        this.currentCustomer.emit(customer);
      }
    }
  }

  customerChanged(event) {

    if (event.isInteracted) {

      // nullify the currently selected health authority
      this.selectedapplicationVariant = '';
      this.enableApplyButton(false);

      this.selectedCustomer = event.itemData.customerId;

      if (this.selectedCustomer) {

        const eligibleCustomers = this.storageManagerService.read('eligibleCustomers');

        const customer = eligibleCustomers.find(c => c.customerId === +this.selectedCustomer);
        this.subscriptions = customer.applicationVariants;

        if (this.subscriptions && this.subscriptions.length) {

          if (this.subscriptions.length === 1) {

            if (this.ddwDataScopes) {

              this.ddwDataScopes.dataSource = this.setDataScopes(customer.applicationVariants);
              this.ddwDataScopes.dataBind();

              this.ddwDataScopes.value = customer.applicationVariants[0].applicationVariantId;
              this.ddwDataScopes.text = customer.applicationVariants[0].applicationVariantName;

              this.enableApplyButton(true);
            }
          } else {

            this.displayDatascopeSelection(customer);
          }
        }

        if (!this.showDataScopeSelection || this.subscriptions.length === 1) {

          this.applicationVariantName = customer.applicationVariants[0].applicationVariantName;
          this.selectedapplicationVariant = this.applicationVariantName.toLowerCase();

          this.enableApplyButton(true);
        } else {
          this.ddwDataScopes.value = 0;
          this.enableApplyButton(false);
        }
      }
    } else {

      if (!this.selectedapplicationVariant) {
        this.enableApplyButton(false);
      }
    }
  }


  channelChanged(event) {

    if (event.isInteracted) {
      if (event.itemData) {
        this.selectedapplicationVariant = event.itemData.applicationVariantId;
        this.applicationVariantName = event.itemData.applicationVariantName.toLowerCase();

        if (this.selectedapplicationVariant && this.showDataScopeSelection) {
          this.enableApplyButton(true);
        }
      }
    }
  }

  enableApplyButton(enable) {

    const button = this.dialog.getButtons()[1];

    if (button) {

      if (enable) {
        button.cssClass = '';
        this.applyButtonEnabled = true;
      } else {
        button.cssClass = 'e-disabled';
        this.applyButtonEnabled = false;
      }

    }
  }

  beforeOpenDialog(event) {

    const cust = this.storageManagerService.read('currentCustomer');
    const dataScope = this.storageManagerService.read('dataScope');

    let customer: ICustomer;

    if (cust) {
      customer = typeof cust === 'object' ? cust : JSON.parse(cust);

      if (this.ddwCustomers) {
        this.ddwCustomers.value = customer.customerId;

        if (customer.customerId) {
          this.enableApplyButton(true);
        }
      }

      if (this.ddwDataScopes) {

        this.ddwDataScopes.dataSource = customer.applicationVariants;
        this.ddwDataScopes.dataBind();

        if (dataScope) {

          const ds = customer.applicationVariants.find(d => d.applicationVariantName.toLowerCase() === dataScope.toLowerCase());

          this.ddwDataScopes.value = ds ? +ds.applicationVariantId : 0;
          this.ddwDataScopes.text = ds ? ds.applicationVariantName : '';

          this.enableApplyButton(true);
        } else {

          this.ddwDataScopes.value = null;
          this.ddwDataScopes.text = null;

          this.enableApplyButton(false);
        }
      }

      this.displayDatascopeSelection(customer);
    }
  }
  displayDatascopeSelection(customer) {

    if (location.pathname !== '/'
      && location.pathname !== '/home'
      && !location.pathname.includes('/fileupload')
      && location.pathname !== '/support'
      && !location.pathname.includes('/clientsettings')
      && !location.pathname.includes('/exportdata')) {
      this.showDataScopeSelection = true;
    } else {

      if ((this.navigateToInput.includes('/inventory')
        || this.navigateToInput.includes('/managesubmissionitems')
        || this.navigateToInput.includes('/submissionhistory'))
        && (customer.applicationVariants && customer.applicationVariants.length > 1)) {


        this.showDataScopeSelection = true;
      } else {

        this.showDataScopeSelection = false;
      }
    }
  }

  setDataScopes(dataSource): any[] {

    const data: any[] = [];

    if (dataSource && dataSource.length) {

      dataSource.forEach((element) => {
        const ds = { value: 0, text: '' };
        ds.value = +element.applicationVariantId;
        ds.text = element.applicationVariantName;

        data.push(ds);
      });
    }

    return data;
  }

}
